export const Action = {
  MANAGE: 'manage', // must be "manage" case-sensitve, define by CASL
  CREATE: 'create',
  READ: 'read', // get list
  UPDATE: 'update',
  DELETE: 'delete',
  RESET_PASSWORD: 'reset_password',
  EXPORT_EXCEL: 'export_excel',
  OPEN_REVISE: 'open_revise',
  READ_DETAIL: 'read_detail',
  RESTORE: 'restore',
  SEND_MAIL: 'send_mail',
  READ_PREQUALIFICATION: 'read_prequalification',
  UPDATE_PREQUALIFICATION: 'update_prequalification',
  APPROVE: 'approve',
  UPDATE_DEADLINE: 'update_deadline',
};

export const Subject = {
  ALL: 'all', // must be "all" case-sensitve, define by CASL
  USER: 'user',
  EMPLOYEE: 'employee',
  PROJECT_PROPOSAL: 'project_proposal',
  PUB_PROJECT_PROPOSAL: 'pub_project_proposal',
  PROGRAM: 'program',
  COUNCIL: 'council',
  STATISTIC: 'statistic',
  STATISTIC_DETAIL: 'statistic_detail',
  CONTACT: 'contact',
  RESEARCH_KPI: 'research_kpi',
  RESEARCH_KPI_GROUP: 'research_kpi_group',
  RESEARCH_FIELD: 'research_field',
  ORGANIZATION: 'organization',
  PREQUALIFICATION_REVIEW: 'prequalification_review',
  FINANCIAL_REVIEW: 'financial_review',
  SPECIALIZE_REVIEW: 'specialize_review',
  MIDTERM_REVIEW: 'midterm_review',
  ACCEPTANCE_REVIEW: 'acceptance_review',
  LIQUIDATION_REVIEW: 'acceptance_review',
  PROJECT: 'project',
  SUMMARY_REPORT: 'summary-report',
  BONUS_EXPENDITURE: 'bonus_expenditure',
  FINANCIAL_ADJUSTMENT: 'financial_adjustment',
  LIQUIDATION: 'liquidation',
  EXTEND_IMPLEMENTATION_TIME: 'extend_implementation_time',
  PERSONNEL_ADJUSTMENT: 'personnel_adjustment',
  ADJUSTMENT_COMMENT: 'adjustment_comment',
  PROPOSAL: 'proposal',
  PROPOSAL_PROGRAM: 'proposal_program',
  REVIEW: 'review',
};
